module.exports = "https://coursera_assets.s3.amazonaws.com/images/9daa25f9291b8033f131aa1662f1c5a1.png";